class LoginSocialService {
    constructor(http, store) {
        this.http = http;
        this.store = store;
    }

    async listarLoginsSociais(params = {}) {
        try {
            const response = await this.http.get('login-social', {
                params: {
                    page: params.page || 1,
                    limit: params.limit || 10,
                    search: params.search || '',
                    perfil: params.perfil || '',
                    sort_by: params.sortBy || '',
                    sort_desc: params.sortDesc ? 1 : 0
                }
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao listar logins sociais:', error);
            throw error;
        }
    }

    async listarApresentantes() {
        try {
            const response = await this.http.get('apresentantes');
            return response.data;
        } catch (error) {
            console.error('Erro ao listar apresentantes:', error);
            throw error;
        }
    }

    async criarLoginSocial(dados) {
        try {
            const response = await this.http.post('login-social', dados);
            return response.data;
        } catch (error) {
            console.error('Erro ao criar login social:', error);
            throw error;
        }
    }

    async atualizarLoginSocial(id, dados) {
        try {
            const response = await this.http.put(`login-social/${id}`, dados);
            return response.data;
        } catch (error) {
            console.error('Erro ao atualizar login social:', error);
            throw error;
        }
    }
}

export default LoginSocialService;
